export enum VoicesActionTypes {
  FETCH_SUCCESS = 'voices/FETCH_SUCCESS',
  FETCH_ERROR = 'voices/FETCH_ERROR',
}
